var $0b04512118591d2a$exports = {};
$0b04512118591d2a$exports = {
  "calendar": `Kalender`,
  "day": `dag`,
  "dayPeriod": `fm/em`,
  "endDate": `Slutdatum`,
  "era": `era`,
  "hour": `timme`,
  "minute": `minut`,
  "month": `m\xe5nad`,
  "second": `sekund`,
  "selectedDateDescription": args => `Valt datum: ${args.date}`,
  "selectedRangeDescription": args => `Valt intervall: ${args.startDate} till ${args.endDate}`,
  "selectedTimeDescription": args => `Vald tid: ${args.time}`,
  "startDate": `Startdatum`,
  "timeZoneName": `tidszon`,
  "weekday": `veckodag`,
  "year": `\xe5r`
};
export { $0b04512118591d2a$exports as default };